import {useGetDrugsCategory, useGetDrugsCategoryActivities} from '@/modules/basic-data/categories/api'
import {DrugsCategory, EventLog} from '@cypro/engine/schema'
import {createContext, PropsWithChildren, useContext} from 'react'

interface State {
  category: DrugsCategory
  isSubcategory: boolean
  activities?: EventLog[]
}

interface Props extends PropsWithChildren {
  category: DrugsCategory
}

const DrugsCategoryContext = createContext<State>({} as State)

export function DrugsCategoryProvider({children, category: initialCategory}: Props) {
  const [category] = useGetDrugsCategory(initialCategory.id)
  const [activities] = useGetDrugsCategoryActivities(initialCategory.id)
  const _category = category || initialCategory

  return (
    <DrugsCategoryContext value={{category: _category, isSubcategory: Boolean(_category.parentId), activities}}>
      {children}
    </DrugsCategoryContext>
  )
}

export function useDrugsCategoryContext() {
  return useContext(DrugsCategoryContext)
}
